export default __webpack_public_path__ + "static/media/bookmarkActiveHover.52625c31.svg";